var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFollowerVine4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2560 1440",
    preserveAspectRatio: "xMidYMid slice",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "vineGradient",
    x1: 0,
    y1: 0,
    x2: 50,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#264d3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#5fae8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#b2f0e3"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "layer"
  }, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    d: "m2602.96,278.52c-120.37,-20.37 -174.07,-422.22 -325.93,-361.11c-151.85,61.11 -81.48,453.7 -196.3,533.33c-114.81,79.63 -253.7,42.59 -302.96,10.37c-49.26,-32.22 -111.85,-130.74 -65.56,-241.85c46.3,-111.11 107.41,-92.59 117.41,-165.56c10,-72.96 -56.3,-167.78 -124.07,-138.89c-67.78,28.89 -69.26,139.63 -133.33,196.3c-64.07,56.67 -124.81,50.74 -176.67,6.3c-51.85,-44.44 -27.78,-116.67 -149.26,-145.19c-121.48,-28.52 -330.37,-97.41 -440.74,-96.3c-110.37,1.11 -210,61.85 -372.22,107.41c-162.22,45.56 -272.96,250.74 -311.11,335.19c-38.15,84.44 -37.78,247.04 4.81,341.48c42.59,94.44 201.85,148.15 202.59,302.96c0.74,154.81 -306.3,95.19 -307.41,464.81c-1.11,369.63 397.41,269.26 533.33,170.37c135.93,-98.89 40,-280.74 173.33,-388.15c133.33,-107.41 250,131.48 415.56,97.41c165.56,-34.07 -10,-452.96 218.52,-516.67c228.52,-63.7 178.89,322.96 427.78,283.33c248.89,-39.63 101.11,-441.85 425.93,-487.04c324.81,-45.19 484.44,178.52 450,366.67c-34.44,188.15 130.74,300.74 120.37,262.96c-10.37,-37.78 127.04,258.15 125.93,257.41c-1.11,-0.74 1054.81,-362.22 1053.7,-362.96c-1.11,-0.74 -717.41,-77.04 -718.52,-633.33c-1.11,-556.3 -524.81,-178.89 -645.19,-199.26z",
    fill: "#000000",
    fillOpacity: 0,
    id: "svg_22",
    stroke: "#000000",
    strokeWidth: 5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollowerVine4);
export default __webpack_public_path__ + "static/media/followerVine4.bcb6a396a22f94bd17600d23c7a15cac.svg";
export { ForwardRef as ReactComponent };